"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCatalogChannelBase = void 0;
var tslib_1 = require("tslib");
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var transcoding_statuses_1 = require("@wix/wix-vod-constants/dist/common/transcoding-statuses");
var channel_types_1 = require("@wix/wix-vod-constants/dist/common/channel-types");
var object_1 = require("@wix/wix-vod-shared/dist/src/common/utils/object");
var entity_id_1 = require("../normalizers/entity-id");
var video_item_1 = require("./video-item");
var mapTimestampToDate = function (channel, targetKey) {
    channel[targetKey] = new Date(channel[targetKey] * 1000);
};
var mapStatsInfo = function (channel) {
    // TODO: WHYYYY?
    if (channel.statsInfo) {
        channel.statsInfo = lodash_1.default.mapValues(channel.statsInfo, function (list) {
            // get rid of empty categories & tags
            var nonEmptyList = lodash_1.default.filter(list, function (item) { return Boolean(item.value); });
            return lodash_1.default.uniqBy(nonEmptyList, 'value');
        });
    }
};
var cleanupVideoCountsForYoutubeFeed = function (channel) {
    // skip videosCount for youtube feed, should be done on BE
    if (channel.channelType !== channel_types_1.CHANNEL_TYPES.CHANNEL) {
        delete channel.videosCount;
    }
};
var parseFeaturedItem = function (channel) {
    if (!channel.featuredItem) {
        return;
    }
    if (!channel.featuredItem.mediaStatus ||
        channel.featuredItem.mediaStatus === transcoding_statuses_1.TRANSCODING_STATUSES.NONE) {
        delete channel.featuredItem;
        if (channel.videosCount) {
            channel.videosCount -= 1;
        }
        return;
    }
    if (channel.featuredItem.itemId) {
        // cleanup in new VOD backend version
        channel.featuredItem = (0, video_item_1.parseVideoItem)(channel.featuredItem);
    }
};
var parseCatalogChannelBase = function (channel) {
    channel = lodash_1.default.cloneDeep(channel);
    channel = (0, object_1.keysToCamelCase)(channel);
    mapTimestampToDate(channel, 'createdTs');
    mapTimestampToDate(channel, 'externalCreatedTs');
    mapTimestampToDate(channel, 'updatedTs');
    mapStatsInfo(channel);
    channel.id = (0, entity_id_1.normalizeId)(channel.itemId);
    channel.customCoverUrl = channel.customCoverUrl || null;
    channel.videosCount = channel.usedCount;
    channel.urlType = channel.urlType || '';
    channel.channelType = channel.channelType || channel_types_1.CHANNEL_TYPES.CHANNEL;
    delete channel.itemId;
    delete channel.usedCount;
    delete channel.publishChanges;
    parseFeaturedItem(channel);
    cleanupVideoCountsForYoutubeFeed(channel);
    return channel;
};
exports.parseCatalogChannelBase = parseCatalogChannelBase;
//# sourceMappingURL=catalog-channel.js.map